import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  Typography,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Avatar,
  CircularProgress,
  MenuItem,
  Select,
  InputLabel,
  FormControl,Menu ,ListItemIcon, ListItemText,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { GlobalStyles } from "@mui/system";
import { useFormik } from 'formik';
import {  IconButton } from "@mui/material";
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { useAuth } from "../../../AuthProvider";


import ExcelJS from "exceljs";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import PresentToAllIcon from '@mui/icons-material/PresentToAll';
import SimCardDownloadIcon from '@mui/icons-material/SimCardDownload';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import FilePresentIcon from '@mui/icons-material/FilePresent';


const baseUrl = process.env.REACT_APP_API_BASE_URL;
const OrgDashAbsentTeachersList = () => {
  const navigate = useNavigate();
  const {oId,pId}=useAuth();
  const [loading, setLoading] = useState(true);
  const [selectedClass, setSelectedClass] = useState("");
  const [selectedSection, setSelectedSection] = useState("");

    const [searchQuery, setSearchQuery] = useState("");
    const [filteredData, setFilteredData] = useState([]);


    const [exportAnchorEl, setExportAnchorEl] = useState(null);
    const isExportMenuOpen = Boolean(exportAnchorEl);
    
    const handleExportClick = (event) => {
      setExportAnchorEl(event.currentTarget);
    };
    
    const handleExportClose = () => {
      setExportAnchorEl(null);
    };
    const handleClose = () => {
      setExportAnchorEl(null);
    };
  


  useEffect(() => {
    // Fetch data from API
    const fetchData = async () => {
      setLoading(true); // Set loading state
      try {
        const today = new Date();
        const formattedDate = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, "0")}-${String(today.getDate()).padStart(2, "0")}`;

        const response = await fetch(`${baseUrl}/api/attendance/teacher/absent/${formattedDate}/${oId}`); // Replace with your API URL
        const data = await response.json();
        // setFilteredData(data); // Set the data from API
        if (Array.isArray(data)) {
          setFilteredData(data);
        } else {
          console.error("Unexpected API response: ", data);
          setFilteredData([]); // Default to an empty array
        }
      } catch (error) {
        console.error("Error fetching data: ", error);
        setFilteredData([]); // Set the data from API
      } finally {
        setLoading(false); // Set loading to false after fetching
      }
    };
    fetchData();
  }, [oId]);

   // Filter data based on searchQuery
   const filteredResults = filteredData.filter((item) => {
    const FirstName = item.firstName ? item.firstName.toLowerCase() : "";
    const LastName = item.lastName ? item.lastName.toLowerCase() : "";
    const fullName = `${FirstName} ${LastName}`.trim(); // Combine first and last names
    const EmployeeId = item.employeeId ? item.employeeId.toString() : ""; // Ensure it's a string
  
    return (
      fullName.includes(searchQuery.toLowerCase()) || // Search in full name
      EmployeeId.includes(searchQuery) // Search in Teacher id
    );
  });



  const exportToExcel = () => {
    const processedData = filteredResults.map(({ 
      employeeId, firstName, lastName, subject, mobileNo, emailId,status
    }) => ({
      EmpId: employeeId,  
      Name: `${firstName} ${lastName}`,  
      Subject: subject,
      Phone: mobileNo,
      EmailId: emailId,
      status:status,
    }));
  
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("AbsentTeachersList");
  
    // Add headers
    worksheet.columns = [
      { header: "EmpId", key: "EmpId", width: 15 },
      { header: "Name", key: "Name", width: 25 },
      { header: "Subject", key: "Subject", width: 20 },
      { header: "Phone", key: "Phone", width: 15 },
      { header: "EmailId", key: "EmailId", width: 30 },
      { header: "status", key: "status", width: 15},
    ];
  
    // Add data to worksheet
    processedData.forEach((data) => {
      worksheet.addRow(data);
    });
  
    // Style headers
    worksheet.getRow(1).eachCell((cell) => {
      cell.font = { bold: true };
      cell.alignment = { horizontal: "center" };
      cell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "87CEEB" }, // Light Blue Header
      };
    });
  
    // Write and download file
    workbook.xlsx.writeBuffer().then((buffer) => {
      const blob = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = "AbsentTeachersList.xlsx";
      link.click();
    });
  
    handleExportClose();
  };
  
  // ✅ Export to PDF with same fields
  const exportToPDF = () => {
    const doc = new jsPDF();
  
    // Title
    doc.setFontSize(16);
    doc.setFont("helvetica", "bold");
    doc.text("Absent Teachers List", 14, 10);
  
    // Date
    doc.setFontSize(10);
    doc.setFont("helvetica", "normal");
    doc.text("Generated On: ", 14, 16);
    doc.setFont("helvetica", "bold");
    doc.text(new Date().toLocaleDateString(), 40, 16);
  
    // Table Headers & Data
    doc.autoTable({
      startY: 25,
      head: [["S.No", "EmpId", "Name", "Subject", "Phone", "EmailId", "status"]],
      body: filteredResults.map((row, index) => [
        index + 1,
        row.employeeId,
        `${row.firstName} ${row.lastName}`,
        row.subject,
        row.mobileNo,
        row.emailId,
        row.status
      ]),
      styles: {
        lineWidth: 0.2,
        lineColor: "#B6B9CD",
      },
      headStyles: {
        fillColor: [63, 81, 181], // Dark Blue Header
        textColor: [255, 255, 255],
        halign: "center",
      },
      bodyStyles: {
        halign: "center",
      },
      theme: "grid",
    });
  
    doc.save("AbsentTeachersList.pdf");
    handleExportClose();
  };
  
  
  
  const exportToJSON = () => {
    const jsonString = `data:text/json;charset=utf-8,${encodeURIComponent(
      JSON.stringify(filteredResults, null, 2)
    )}`;
    const link = document.createElement("a");
    link.href = jsonString;
    link.download = `AbsentTeachersList.json`;
    link.click();
    handleExportClose();
  };
  


  return (
    <Box sx={{ mt: "5%", mr: "1%", ml: "1%" }}>
      <Card
        sx={{
          marginTop:"60px",
          width: "100%",
          borderRadius: 3,
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
        }}
      >
        <CardContent>
         
           <Box display="flex" alignItems="center" sx={{marginBottom:2}}>
                              <IconButton onClick={() => navigate(-1)} sx={{ color: '#2e2a54' }}>
                                <KeyboardBackspaceIcon fontSize="medium" />
                              </IconButton>
                              <Typography variant="h4" component="h3" sx={{fontWeight:'bold' }}>
                              Absent Teachers List
                              </Typography>
                            </Box>

                            <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
  {/* Left-aligned Search Field */}
  <TextField
    label="Search by Name or Id "
    variant="outlined"
    size="small"
    style={{ width: '250px' }} // Set fixed width
    value={searchQuery}
    onChange={(e) => setSearchQuery(e.target.value)}
  />

  {/* Right-aligned Download Button */}
  <Button 
    variant="contained" 
    onClick={handleExportClick}  
    style={{ backgroundColor: '#3C3972', fontWeight: 'bold' }}
    startIcon={<PresentToAllIcon />}  
  >
    Export
  </Button>

  <Menu
    anchorEl={exportAnchorEl}
    open={isExportMenuOpen}
    onClose={handleExportClose}
    sx={{
      "& .MuiPaper-root": {
        backgroundColor: "#f5f5f5",
        borderRadius: "8px",
      },
    }}
  >
    <MenuItem 
      onClick={exportToExcel}
      sx={{
        color: "#3f51b5",
        fontWeight: "bold",
        "&:hover": {
          backgroundColor: "#e8f0fe",
        }
      }}
    >
      <ListItemIcon sx={{ color: '#00796b' }}>
        <SimCardDownloadIcon />
      </ListItemIcon>
      <ListItemText primary="Excel" sx={{ fontWeight: 'bold', color: '#00796b' }} />
    </MenuItem>
    
    <MenuItem 
      onClick={exportToPDF}
      sx={{
        color: "#d32f2f",
        fontWeight: "bold",
        "&:hover": {
          backgroundColor: "#fdecea",
        }
      }}
    >
      <ListItemIcon sx={{ color: '#d32f2f' }}>
        <PictureAsPdfIcon />
      </ListItemIcon>
      <ListItemText primary="PDF" sx={{ fontWeight: 'bold', color: '#d32f2f' }} />
    </MenuItem>
    
    <MenuItem 
      onClick={exportToJSON}
      sx={{
        color: "#388e3c",
        fontWeight: "bold",
        "&:hover": {
          backgroundColor: "#e8f5e9",
        }
      }}
    >
      <ListItemIcon sx={{ color: '#6a1b9a' }}>
        <FilePresentIcon />
      </ListItemIcon>
      <ListItemText primary="JSON" sx={{ fontWeight: 'bold', color: '#6a1b9a' }} />
    </MenuItem>
  </Menu>







</Box>


<GlobalStyles
          styles={{
            '.custom-sidebar-scrollbar': {
              scrollbarWidth: 'thin', // For Firefox
              scrollbarColor: 'grey #e0e0e0',
            },
            '.custom-sidebar-scrollbar::-webkit-scrollbar': {
              width: '6px', // For WebKit-based browsers
            },
            '.custom-sidebar-scrollbar::-webkit-scrollbar-track': {
              background: '#f1f1f1', // Track color
            },
            '.custom-sidebar-scrollbar::-webkit-scrollbar-thumb': {
              backgroundColor: 'grey', // Thumb color
              borderRadius: '10px',
            },
            '.custom-sidebar-scrollbar::-webkit-scrollbar-thumb:hover': {
              backgroundColor: '#555',
            },
          }}
        />

          <TableContainer
            component={Paper}
            sx={{
              borderRadius: 2,
              boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
              maxHeight: "800px",
              overflow: "auto",

            }}
             className="custom-sidebar-scrollbar"
          >
            <Table stickyHeader>
  <TableHead  >
    <TableRow >
      <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px", textAlign: "center" ,backgroundColor: "#fff9c4" ,fontWeight:'bold',fontSize:'14px'}}>S.No</TableCell>
      <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px" , textAlign: "center",backgroundColor: "#fff9c4" ,fontWeight:'bold',fontSize:'14px'}}>Tech Id</TableCell>
      {/* <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px",backgroundColor: "#fff9c4", textAlign: "center"  }}>Class</TableCell>
      <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px",backgroundColor: "#fff9c4", textAlign: "center"  }}>Section</TableCell> */}
      
      <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px", textAlign: "center" , whiteSpace: "nowrap",backgroundColor: "#fff9c4", overflow: "hidden", textOverflow: "ellipsis" ,fontWeight:'bold',fontSize:'14px'}}>Teacher Name</TableCell>
      <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px", textAlign: "center" , whiteSpace: "nowrap",backgroundColor: "#fff9c4", overflow: "hidden", textOverflow: "ellipsis" ,fontWeight:'bold',fontSize:'14px'}}>Subject</TableCell>
      {/* <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px", textAlign: "center" , whiteSpace: "nowrap",backgroundColor: "#fff9c4", overflow: "hidden", textOverflow: "ellipsis" }}>Date</TableCell>
      <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px", textAlign: "center" , whiteSpace: "nowrap", backgroundColor: "#fff9c4",overflow: "hidden", textOverflow: "ellipsis" }}>Time In</TableCell>
      <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px", textAlign: "center" , whiteSpace: "nowrap", backgroundColor: "#fff9c4",overflow: "hidden", textOverflow: "ellipsis" }}>Time Out</TableCell> */}
      <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px", textAlign: "center" ,backgroundColor: "#fff9c4" ,fontWeight:'bold',fontSize:'14px'}}>Mobile No</TableCell>
      <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px",backgroundColor: "#fff9c4", textAlign: "center"  ,fontWeight:'bold',fontSize:'14px'}}>Email</TableCell>
      <TableCell sx={{ padding: "4px" ,backgroundColor: "#fff9c4", textAlign: "center" ,fontWeight:'bold',fontSize:'14px',fontWeight:'bold',fontSize:'14px'}}>Status</TableCell>

   
      {/* <TableCell sx={{ padding: "4px" ,backgroundColor: "#fff9c4", textAlign: "center" }}>Full Details</TableCell> */}
    </TableRow>
  </TableHead>
  {loading ? (
    <TableBody>
       <TableCell colSpan={13} style={{ textAlign: "center", padding: "20px" }}>
                                                          <Box display="flex" flexDirection="column" alignItems="center">
                                                          <CircularProgress />
                                                          <Typography variant="body2" sx={{ mt: 1 }}>
                                                            Loading Data...
                                                          </Typography>
                                                        </Box>
                                                      </TableCell>
    </TableBody>
  ) : filteredResults.length === 0 ? (
    <TableBody>
      <TableRow>
        <TableCell colSpan={13} sx={{ textAlign: "center" }}>
          No data found
        </TableCell>
      </TableRow>
    </TableBody>
  ) : (
   <TableBody>
  {filteredResults.map((row, index) => (
    <TableRow key={row.admissionNumber} style={{
      backgroundColor: "white",
      transition: "background-color 0.3s",
    }}
    onMouseEnter={(e) => {
      e.currentTarget.style.backgroundColor = "#f5f5f5"; // Hover color
    }}
    onMouseLeave={(e) => {
      e.currentTarget.style.backgroundColor = "white"; // Default color
    }}>
      <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px", textAlign: "center" }}>
        {index + 1}
      </TableCell>
    
      <TableCell sx={{ borderRight: "1px solid #ddd", padding: "3px", textAlign: "center" }}>{row.employeeId}</TableCell>
      <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", textAlign: "center" }}>{`${row.firstName} ${row.lastName}`}</TableCell>
      <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", textAlign: "center" }}>{row.subject || "Subject Not Assigned"}</TableCell>
    
      <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px", textAlign: "center" }}>
        {row.mobileNo || "N/A"}
      </TableCell>
      <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px", textAlign: "center" }}>
        {row.emailId || "N/A"}
      </TableCell>
      <TableCell sx={{ borderRight: "1px solid #ddd", padding: "4px", textAlign: "center" }}>
        <Button
            variant="outlined"
            color="error"
            style={{
              backgroundColor: "#ED3638",
              color: "#fff",
              fontWeight: "bold",
              textTransform: "none",
              borderRadius: "20px",
            }}
          >
             Absent{/* {row.status}  */}
          </Button>
       
      </TableCell>

    </TableRow>
  ))}
</TableBody>


  )}
</Table>

          </TableContainer>
        </CardContent>
      </Card>
    </Box>
  );
};

export default OrgDashAbsentTeachersList;